module.exports = __webpack_public_path__ + "img/haya-logo-blk.6292cca1.png";